export default class ChartOption {
  constructor({
    type,
    columns = [],
    excluded = [],
    excludedDataOptions = [],
    required = false,
  }) {
    this.type = type;
    this.columns = columns;
    this.excluded = excluded;
    this.excludedDataOptions = excludedDataOptions;
    this.required = required;
  }
}
